module.exports = __webpack_public_path__ + "img/04.41818681.png";